var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;


























jade_mixins["readonly-block"] = jade_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<div ng-if=\"vm.isReadonly() || !vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-class=\"{'clearfix-hover' : vm.hoverPosition}\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div><div ng-if=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten\" ng-show=\"!vm.editMode\" ng-click=\"!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? vm.toggleEditMode() : null\" data-toggle=\"{{!vm.isReadonly() &amp;&amp; vm.globalBearbeiten ? 'edit' : ''}}\" ng-class=\"{ 'editable' : !vm.isReadonly() &amp;&amp; vm.globalBearbeiten }\" tabindex=\"-1\" class=\"clearfix box_hover\">");
block && block();
buf.push("</div>");
};





































jade_mixins["readonly-block"].call({
block: function(){
buf.push("<div ng-if=\"vm.kontext !== 'zuschuss_vertrag'\"><div class=\"position\"><div>{{vm.idx}}</div><div><span>{{ vm.antragFinanzierungsart.finanzierungsart.fin_kbez }}</span><button ng-click=\"vm.toggleStatusInfo()\" ng-class=\"{ 'active': vm.statusInfo }\" type=\"button\" ng-attr-title=\"Zusatzinformation bezüglich {{vm.idx}} {{vm.antragFinanzierungsart.finanzierungsart.fin_kbez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-attr-aria-expanded=\"{{vm.statusInfo}}\" ng-if=\"vm.modul.regel.afr_astbez\" class=\"btn btn-icon toggle-info\"><span class=\"glyphicon glyphicon-info-sign\"></span></button></div><div>{{ vm.get_antrag_betrag() }}</div><div class=\"version\">{{ vm.snapshot.asn_snapshot.zuschuss.zuschuss | currency }}</div><div class=\"procent\"><span ng-if=\"vm.show_prozente()\">{{vm.get_prozent() | number:2 }}&nbsp;%</span></div><!-- Aktionsbereich--><div>&nbsp;</div></div><div ng-show=\"vm.modul.regel.afr_kbez || vm.modul.regel.afr_bezeichnung\" class=\"rules\"><h5 ng-bind-html=\"vm.modul.regel.afr_kbez\"></h5><div ng-bind-html=\"vm.modul.regel.afr_bezeichnung\"></div></div><div ng-show=\"vm.statusInfo\" role=\"alert\" class=\"info\"><button ng-attr-title=\"Zusatzinformation bezüglich {{vm.idx}} {{vm.antragFinanzierungsart.finanzierungsart.fin_kbez}} {{vm.statusInfo ? 'ausblenden': 'einblenden'}}\" ng-click=\"vm.toggleStatusInfo()\" class=\"btn btn-icon btn-absolute\"><i class=\"glyphicon glyphicon-remove\"></i></button><div ng-bind-html=\"vm.modul.regel.afr_astbez\"></div></div><div class=\"position-detail show\"><div ng-repeat=\"m in vm.infoprovider.details[vm.modul.regel.afr_id].detail_meldungen\" class=\"position gap\"><!-- version icon--><!--div--><!-- idx--><div class=\"icon\"></div><div class=\"title\">{{ m[0] }}</div><div>&nbsp;{{ m[1] | currency}}</div><div class=\"version\">{{ vm.snapshot.asn_snapshot.zuschuss.details[vm.modul.regel.afr_id].detail_meldungen[$index][1] || 0 | currency }}</div><div class=\"procent\"></div><!-- actions--><div>&nbsp;</div></div></div></div><div ng-if=\"vm.kontext === 'zuschuss_vertrag'\" class=\"position\"><div>{{ vm.vertragFinanzierungsart.finanzierungsart.fin_kbez  }}</div><div>{{ vm.vertragFinanzierungsart.vf_betrag_bewilligt | currency }}<span ng-bind-html=\"vm.get_vertrag_prozent('bewilligt')\"></span></div><div></div><div>{{ vm.get_vertrag_betrag() }}<span ng-bind-html=\"vm.get_vertrag_prozent('aktualisiert')\"></span></div><div></div></div>");
}
});;return buf.join("");
}